import { h } from 'preact';
import Store from 'store/store';
import { PLACEHOLDER_TYPE } from 'utils/constants';
import { getCurrentMovieType, hasUnpublishedPlaceholderChanges, getMovieType, getMovieTypeLabel } from 'utils/data';
import * as jsonPointer from 'utils/jsonPointer';
import { isPowsterEmployee } from 'utils/roles';
import { isBaseRegion } from 'utils/studioConfig';
import { getThundrLink } from 'utils/thundr';

import FieldWrapper from 'components/editor/settings/fieldWrapper';
import Thundr from 'components/icons/thundr';
import InlineSelect from 'components/inlineSelect/inlineSelect';
import MovieSidebar from 'components/editor/movies/movieSidebar/movieSidebar.js';

import s from 'components/editor/movies/movieSidebar/movieSidebarUniversal.sss';

export default class UniversalMovieSidebar extends MovieSidebar {
	s = s;

	constructor(props) {
		super(props);
		this.loadPublishedData();
		this.onPageTypeUpdate = this.onPageTypeUpdate.bind(this);
	}

	async loadPublishedData() {
		await Store.get().publishedDataPromise;
		this.setState({});
	}

	async onPageTypeUpdate(e) {
		jsonPointer.setDeep(Store.get().data, `${this.props.activeSection.dataRoot || ''}/content/activeType`, e.target.value);
	}

	renderSubHeading() {
		const movie = this.state.movieData;
		const thundrLink = getThundrLink(movie);
		const showThundrLink = isPowsterEmployee() && thundrLink;
		
		return (
			<div class={s.subHeading}>
				{showThundrLink && <a class={s.thundrLink} href={thundrLink} target="_blank" rel="noopener noreferrer"><Thundr /> Thundr App Connected</a>}
				{this.renderPageStatus()}
			</div>
		);
	}

	renderPlaceholderBadge() {
		// Determine if there are unpublished changes specifically for the placeholder page
		const unpublishedChanges = hasUnpublishedPlaceholderChanges(this.data);
		const isLive = this.data?.commits?.publish?.published_status?.endsWith(PLACEHOLDER_TYPE.toUpperCase());

		return this.renderBadge(isLive ? 'live' : 'draft', unpublishedChanges);
	}

	renderMoviePlatformBadge() {
		const { current, publish } = this.data?.commits || {};
		const unpublishedChanges = current?.at > publish?.at;
		const movieType = getMovieType(this.data).toUpperCase();
		const isLive = publish?.published_status?.endsWith(movieType);

		return this.renderBadge(isLive ? 'live' : 'draft', unpublishedChanges);
	}

	renderPageStatus() {
		if (isBaseRegion()) return null;

		const activeType = getCurrentMovieType(this.data) || PLACEHOLDER_TYPE;
		const movieType = getMovieType(this.data);
		const movieStatus = this.getMovieStatuses();
		const hidePlacholder = !this.data?.commits?.publish?.published_status?.endsWith(movieType.toUpperCase());

		return (
			<FieldWrapper class={s.movieType} label="Movie type" help="Select the type of movie page to edit and publish">
				<InlineSelect value={activeType} onChange={this.onPageTypeUpdate} dark transparent fullWidth vertical>
					{hidePlacholder && (
						<option class={s.pageType} value={PLACEHOLDER_TYPE}>
							<div class={s.typeTitle}>
								<span>{getMovieTypeLabel(PLACEHOLDER_TYPE)}</span>
								{this.renderPlaceholderBadge()}
							</div>
						</option>
					)}
					<option class={s.pageType} value={movieType}>
						<div class={s.typeTitle}>
							<span>{getMovieTypeLabel(movieType)}</span>
							{this.renderMoviePlatformBadge()}
						</div>
						<span class={s.movieStatus}>{movieStatus.join(', ')}</span>
					</option>
				</InlineSelect>
			</FieldWrapper>
		);
	}
}
